import { type JSX, Show } from 'solid-js';
import { t } from '../../i18n';

// The per-preset number inside each preset button (notifications overhaul,
// slice 21): "Only urgent — about 2 a week". Rendered by the preset button's
// own parent, which owns the space before it (`NotificationPresets.tsx`), so
// the button's accessible name stays one run of words.
//
// `undefined` renders NOTHING, not "about 0": the caller passes a number only
// when the week was measured (`presetEstimates`, `lib/notification-estimate.ts`).
// A measured zero is a fact about the reader's week and prints like any other
// number; an unmeasured one is a placeholder metric, and this page does not
// ship those.
//
// `floor` re-words the number "at least {n}": the estimate's event read hit its
// row cap, so every total in it is a floor (`truncated`, the wire schema).

export function NotificationPresetEstimate(props: {
  readonly estimate?: number | undefined;
  readonly floor?: boolean | undefined;
}): JSX.Element {
  // The `?? 0` is unreachable by construction — the `Show` guard owns the
  // undefined case — and only satisfies the type of the interpolation below.
  const number = (): number => props.estimate ?? 0;
  return (
    <Show when={props.estimate !== undefined}>
      <span class="notification-presets__estimate">
        {t(
          props.floor
            ? 'notifications_settings.preset.weekly_estimate_floor'
            : 'notifications_settings.preset.weekly_estimate',
          { n: number() },
        )}
      </span>
    </Show>
  );
}
